/* eslint-disable no-empty */
import { Service } from '@genial/services';
import { useCallback, useState } from 'react';
import { useSetRecoilState } from 'recoil';

import { tradingListItemDetailState } from './atom';

export const useTradingActions = (idConta: number, sinacor: number, idContaSuperPNP: number) => {
  const [isFetchingTradingListItemDetail, setIsFetchingTradingListItemDetail] = useState(false);
  const setTradingListItemDetailState = useSetRecoilState(
    tradingListItemDetailState({ idConta, sinacor, idContaSuperPNP })
  );

  const fetchTradingListItemDetail = useCallback(async () => {
    setIsFetchingTradingListItemDetail(true);

    try {
      const intradayListResponse =
        await Service.External.Extranet.Movimentacao.V1.movimentacaoObterResultadoDia({
          sinacor,
          idConta,
          idContaSuperPNP,
          screenName: 'trading-customer-list',
        });

      if (Array.isArray(intradayListResponse)) {
        setTradingListItemDetailState(intradayListResponse);
      }
    } catch (_error) {
    } finally {
      setIsFetchingTradingListItemDetail(false);
    }
  }, [idConta, idContaSuperPNP, setTradingListItemDetailState, sinacor]);

  return {
    fetchTradingListItemDetail,
    isFetchingTradingListItemDetail,
  };
};
